import{post } from '@/utils/request';
import{filerequestAnasysurl,erpserver} from '@/utils/baseUrl';

export async function getTrader(params) {
    return post(erpserver+'/eCommerce/getTrader',params,true)
}
export async function getTraderResources(params) {
    return post(erpserver+'/eCommerce/getTraderResources',params,true)
}
//获取用户公司
export async function getCompany(params) {
    return post(erpserver+'/eCommerce/getCompany',params,true)
}
export async function getWarehouse(params) {
    return post(erpserver+'/eCommerce/getWarehouse',params,true)
}
//保存
export  async  function saveTrader(params) {
    return  post(erpserver+'/eCommerce/saveTrader',params,true)
}
//删除
export  async  function delTraderResource(params) {
    return  post(erpserver+'/eCommerce/delTraderResource',params,true)
}
export  async  function getPzMessage(params) {
    return  post(erpserver+'/eCommerce/getPzMessage',params,true)
}
//上传附件
export const filerequest_url=filerequestAnasysurl;